import * as tslib_1 from "tslib";
import { IgCollection } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
import { SyncableObservableCollection$2 } from "igniteui-react-core";
import { CellKey as CellKey_internal } from './CellKey';
import { IgrCellKey as IgrCellKey } from './igr-cell-key';
var IgrGridSelectedCellsCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrGridSelectedCellsCollection, _super);
    function IgrGridSelectedCellsCollection(list) {
        var _this = _super.call(this) || this;
        if (!IgrCellKey.$type) {
            IgrCellKey.$type = markType(IgrCellKey, "IgrCellKey");
        }
        if (list) {
            for (var i = 0; i < list.length; i++) {
                _this.add(list[i]);
            }
        }
        return _this;
    }
    IgrGridSelectedCellsCollection.prototype._createInnerColl = function () {
        if (!IgrCellKey.$type) {
            IgrCellKey.$type = markType(IgrCellKey, "IgrCellKey");
        }
        var coll = new SyncableObservableCollection$2(IgrCellKey.$type, CellKey_internal.$type, 0);
        coll.compare = function (ext, int) {
            var comp = ext;
            if (comp._implementation) {
                comp = comp._implementation;
            }
            if (comp.equals) {
                return comp.equals(int);
            }
            return comp === int;
        };
        coll.createTo = function (ext) {
            return ext._implementation;
        };
        coll.createFrom = function (int) {
            var ext = int.externalObject;
            if (!ext) {
                ext = new IgrCellKey();
                if (ext) {
                    ext._implementation = int;
                }
            }
            return ext;
        };
        return coll;
    };
    return IgrGridSelectedCellsCollection;
}(IgCollection));
export { IgrGridSelectedCellsCollection };
//# sourceMappingURL=igr-grid-selected-cells-collection.js.map
